import { render, staticRenderFns } from "./location-settings.vue?vue&type=template&id=724b519c&scoped=true&"
import script from "./location-settings.vue?vue&type=script&lang=js&"
export * from "./location-settings.vue?vue&type=script&lang=js&"
import style0 from "./location-settings.vue?vue&type=style&index=0&id=724b519c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724b519c",
  null
  
)

export default component.exports